import { useEffect } from 'react';
import { socket } from '../socket';
import { WsEvents } from '../events';
import { useDispatch } from 'react-redux';
import {
  addBattlefieldSuccess,
  updateBattlefieldSuccess,
  deleteBattlefieldSuccess,
  updatePeriodSuccess,
} from '../../store/battlefield/actions';

export function useBattleFieldOrders() {
  const dispatch = useDispatch();

  /**
   * Get All Event Hook
   */
  // useEffect(() => {
  //   function onDataEvent(args) {
  //     // dispatch({
  //     //   type: 'ADD_LOST_ORDER_SUCCESS',
  //     //   payload: {},
  //     // });
  //   }
  //   socket.emit(WsEvents.battlefield.GET_DATA, onDataEvent);
  // }, []);

  /**
   * Add Event Hook
   */
  useEffect(() => {
    function onAddEvent(res) {
      if ('error' in res) return;
      dispatch(addBattlefieldSuccess(res));
    }
    socket.on(WsEvents.battlefield.ON_ADDED, onAddEvent);

    return () => {
      socket.off(WsEvents.battlefield.ON_ADDED, onAddEvent);
    };
  }, [dispatch]);

  /**
   * Update Event Hook
   */
  useEffect(() => {
    function onUpdateEvent(res) {
      if ('error' in res) return;
      dispatch(updateBattlefieldSuccess(res));
    }
    socket.on(WsEvents.battlefield.ON_UPDATED, onUpdateEvent);

    return () => {
      socket.off(WsEvents.battlefield.ON_UPDATED, onUpdateEvent);
    };
  }, [dispatch]);

  /**
   * Update Battlefield Period Event Hook
   */
  useEffect(() => {
    function onUpdateEvent(res) {
      if ('error' in res) return;
      dispatch(updatePeriodSuccess(res));
    }
    socket.on(WsEvents.battlefield.ON_UPDATED_PERIOD, onUpdateEvent);

    return () => {
      socket.off(WsEvents.battlefield.ON_UPDATED_PERIOD, onUpdateEvent);
    };
  }, [dispatch]);

  /**
   * Delete Event Hook
   */
  useEffect(() => {
    function onDeleteEvent(res) {
      if ('error' in res) return;
      dispatch(deleteBattlefieldSuccess(res));
    }
    socket.on(WsEvents.battlefield.ON_DELETED, onDeleteEvent);

    return () => {
      socket.off(WsEvents.battlefield.ON_DELETED, onDeleteEvent);
    };
  }, [dispatch]);

  return null;
}
